import { WorkspaceRoleBadge } from '@affine/core/desktop/dialogs/setting/workspace-setting/shared/workspace-role-badge';
import { WorkspacePermissionService } from '@affine/core/modules/permissions';
import { useLiveData, useServiceOptional } from '@toeverything/infra';

export function CurrentWorkspaceRoleBadge({
  className,
  dataTestId,
}: {
  className?: string;
  dataTestId?: string;
}) {
  const permission = useServiceOptional(WorkspacePermissionService)?.permission;
  const role = useLiveData(permission?.role$);
  if (role === null || role === undefined) return null;
  return (
    <span className={className} data-testid={dataTestId}>
      <WorkspaceRoleBadge role={role} />
    </span>
  );
}
